import React from 'react';
import { BrowserRouter, Route, Routes } from "react-router-dom"
import Home from './Dashboard/Home';
import Login from './Auth/Login';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { GOOGLE_CLIENT_ID } from './settings';
import { AuthProvider } from './Hooks/useAuth';
import ProtectedRoutes from './Components/ProtectedRoutes';

function App() {
  return (
    <div>
      <BrowserRouter>
        <AuthProvider>
          <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
            <Routes>
              <Route exact path="/" element={ <Login /> } />
              <Route exact path="/dashboard" element={ <ProtectedRoutes><Home /></ProtectedRoutes> }>
                {/* <Route exact path="/dashboard/user-details" element={<UserDetails />} /> */}
              </Route>
            </Routes>
          </GoogleOAuthProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
